import entitiesSharedColors from './entitiesSharedColors';

const mono = '#D25B37';
const monoContrast = '#FFFFFF';
const monoDark = '#87280A';
const monoLight = '#FFC3A1';

export default {
  colors: {
    primary: mono,
    'primary-dark': monoDark,
    'primary-light': monoLight,
    'primary-contrast': monoContrast,
    secondary: mono,
    'secondary-dark': monoDark,
    'secondary-light': monoLight,
    'secondary-contrast': monoContrast,
    tertiary: mono,
    'tertiary-dark': monoDark,
    'tertiary-light': monoLight,
    'tertiary-contrast': monoContrast,
    'accent-1': monoLight,

    ...entitiesSharedColors,
  },
  fonts: {},
};
